import type {
  AiSuggestionForReviewCard,
  EstateOnboardingSuggestion,
} from '@/modules/aiSuggestions/aiSuggestions.contracts';
import type { EstatePage_UnacknowledgedAiSuggestionFragment } from '@/modules/estate/graphql/EstatePageData.generated';
import { AiSuggestionKind } from '@/types/schema';

export enum EstateOnboardingSuggestionGroup {
  DirectHoldings = 'Direct holdings',
  TrustEntities = 'Trust entities',
  TrustHoldings = 'Trust holdings',
  BusinessEntities = 'Business entities',
  BusinessHoldings = 'Business holdings',
}

export type SuggestionsByGroup = Record<
  EstateOnboardingSuggestionGroup,
  AiSuggestionForReviewCard[]
>;

export type EstateOnboardingContextSuggestion =
  | EstateOnboardingSuggestion
  | EstatePage_UnacknowledgedAiSuggestionFragment;

export function isEstateOnboardingReviewCardSuggestion(
  suggestion: EstateOnboardingContextSuggestion
): suggestion is EstateOnboardingContextSuggestion & AiSuggestionForReviewCard {
  return [
    AiSuggestionKind.OnboardingEntity,
    AiSuggestionKind.OnboardingTestamentaryEntity,
    AiSuggestionKind.Asset,
    AiSuggestionKind.Liability,
    AiSuggestionKind.LifeInsurance,
  ].includes(suggestion.kind);
}
